export default __webpack_public_path__ + "fa56ba505bf3bb921b76aef3bca90a64.png";